import { useEffect as o } from "react";
import { throttle as s } from "es-toolkit/function";
const d = (e, t = 300) => {
  o(() => {
    const r = s(e, t);
    return window.addEventListener("resize", r, { passive: !0 }), () => {
      window.removeEventListener("resize", r);
    };
  }, [e, t]);
};
export {
  d as default
};
//# sourceMappingURL=useWindowResize.js.map
